<template>
  <div class="sidebar-help">
    <ul>
      <li v-for="(menu, index) in menus">
        <a
          href="javascript: void(0)"
          class="menu-item"
          :class="{active: index === currIndex}"
          @click="changeMenu(index)">
          {{ menu.type }}
        </a>
      </li>
    </ul>
  </div>  
</template>

<script>
import { types } from '@/page/help/questions-json'

export default {
  props: {
    menus: {
      type: Array,
      required: true
    },
    currIndex: {
      type: Number
    },
    changeMenu: {
      type: Function
    }
  }
}
</script>

<style lang="scss" scoped>
  .sidebar-help {
    padding: 20px 0;
    width: 200px;
    height: 100%;
    background: #f3f3f3;
    border-right: 1px solid #d0d0d0;
    overflow: auto;
  }

  .menu-item {
    padding: 0 30px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;

    &:hover {
      font-weight: bold;
      color: #000;
    }
  }

  .menu-item.active {
    font-weight: bold;
    color: #457EEC;
  }
</style>



// WEBPACK FOOTER //
// src/page/help/components/sidebar.vue